import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import styles from "./DataTable.module.css";
const DataTable = ({ loading, columns, dataSource, rowClassName, id }) => {
  const navigate = useNavigate();
  return (
    <Table
      id={id}
      loading={loading}
      scroll={{ x: "calc(700px + 50%)" }}
      columns={columns}
      dataSource={dataSource}
      rowClassName={(record) => {
        return [rowClassName ? rowClassName(record) : null, styles.Row].join(
          " "
        );
      }}
      onRow={(record) => {
        return {
          onDoubleClick: () => {
            navigate("/Student/" + record.id);
          },
        };
      }}
    />
  );
};
export default DataTable;
